import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { EmitType } from '@syncfusion/ej2-base';
import { Predicate, Query } from '@syncfusion/ej2-data';
import { FilteringEventArgs } from '@syncfusion/ej2-dropdowns';
import { first } from 'rxjs/operators';
import { AzureAccountsService } from 'src/app/core/http-services/azure-accounts.service';
import { AzureEndpointsService } from 'src/app/core/http-services/azure-endpoints.service';
import { AzureNamespacesService } from 'src/app/core/http-services/azure-namespaces.service';
import { PharmacyService } from 'src/app/core/http-services/pharmacy.service';
import { AzureOperationsService } from 'src/app/core/services/azure-operations.service';
import { ALLOWED_MAXIMUM_ENDPOINTS_PER_NAMESPACE } from 'src/app/shared/constants';
import { AzureAccount } from 'src/app/shared/models/azure-accounts.model';
import { AzureEndpoint, AzureEndpointDisplay } from 'src/app/shared/models/azure-endpoints.model';
import { AzureNamespace, UpdateActiveStatusRequest } from 'src/app/shared/models/azure-namespaces.model';
import { AzureErrorResponse } from 'src/app/shared/models/azure-token.model';
import { PharmacyCompact } from 'src/app/shared/models/pharmacy.model';

@Component({
  selector: 'app-edit-endpoint',
  templateUrl: './edit-endpoint.component.html',
  styleUrls: ['./edit-endpoint.component.css']
})
export class EditEndpointComponent implements OnInit {
  isEndpointEntered: boolean = true;
  isAccountSelected: boolean = true;
  isNamespaceSelected: boolean = true;
  isPharmacySelected: boolean = true;

  azureAccounts: AzureAccount[];
  selectedAzureAccount: AzureAccount = null;

  azureNamespaces: AzureNamespace[];
  selectedAzureNamespace: AzureNamespace = null;
  endpointsCountForSelectedNamespace: number = 0;
  textForEndpointsCount: string = '';

  fullUrl: string = "";

  pharmacies: PharmacyCompact[];
  selectedPharmacy: PharmacyCompact;
  fields: Object = {
    text: 'Pharmacy', value: 'PharId'
  };
  watermark: string = 'Select a pharmacy';
  public queryString: string;

  public data: { [key: string]: Object; }[] = [];


  public filterPlaceholder: string = 'Start typing...';
  // filtering event handler to filter a Country
  public onFiltering: EmitType<FilteringEventArgs> = (e: FilteringEventArgs) => {


    if (e.text !== '') {
      this.filterPharmacy(e.text);

      let query: Query = new Query();

      //frame the query based on search string with filter type.
      let predicateQuery = query.where(new Predicate('Pharmacy', 'contains', e.text, true).or('NpiNo', 'startsWith', e.text).or('StreetAddress', 'contains', e.text).or('City', 'contains', e.text).or('State', 'contains', e.text).or('ZIPCode', 'contains', e.text));

      query = predicateQuery;
      //pass the filter data source, filter query to updateData method.
      e.updateData(this.data, query);
    }
  }

  @ViewChild('pharmacyDropdown')
  public pharmacyDropdown: DropDownListComponent;
  public isDropdownReadOnly: boolean = false;
  public pharmacyChanged(): void {
    var selPharmacy = this.pharmacies.find(x => x.PharId == this.pharmacyDropdown.value);
    if (selPharmacy)
      this.selectedPharmacy = selPharmacy;
  }


  @Input()
  currentEndpoint: AzureEndpointDisplay;

  @Output()
  isEndpointSaved: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  azureEndpointId: number;

  error: string;
  isErrorVisible: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private azureNamespaceService: AzureNamespacesService,
    private azureAccountService: AzureAccountsService,
    public activeModal: NgbActiveModal,
    private router: Router,
    private azureOperationsService: AzureOperationsService,
    private azureEndpointsService: AzureEndpointsService,
    private pharmacyService: PharmacyService) {
    this.buildForm();
    this.getAccounts();
    this.getPharmacies();
  }

  ngOnInit(): void {
    //THIS WILL CLOSE THE POPUP IF USER IS FORCED LOGGED OUT
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        var url = window.location.toString();
        if (url.includes('/login'))
          this.activeModal.close();
      }
    });
  }

  endpointForm: FormGroup;

  private buildForm(): void {
    this.endpointForm = this.formBuilder.group({
      endpoint: [null, Validators.required],
      checkActive: [null],
    });
    this.endpointForm.controls.endpoint.disable();
  }

  get f() { return this.endpointForm.controls; }
  isBusy: boolean = false;
  isLoading: boolean = false;
  isValid: boolean = true;

  public setFormValues() {
    if (!this.currentEndpoint)
      return;

    this.f.endpoint.setValue(this.currentEndpoint.EndpointName);
    this.f.checkActive.setValue(this.currentEndpoint.Active);
    this.f.endpoint.disable();

    if (!this.azureAccounts || this.azureAccounts.length == 0) {
      this.azureAccountService.getAccounts(1, 50000)
        .subscribe((dataList: AzureAccount[]) => {
          if (dataList && dataList.length > 0) {
            this.azureAccounts = dataList;
            this.selectedAzureAccount = this.azureAccounts.find(x => x.Id == this.currentEndpoint.AzureAccountId);

            if (this.selectedAzureAccount) {
              this.fetchRelevantNamespaces(this.currentEndpoint);
            }
          }
        });
    }
    else {
      if (this.azureAccounts.some(x => x.Id == this.currentEndpoint.AzureAccountId))
        this.selectedAzureAccount = this.azureAccounts.find(x => x.Id == this.currentEndpoint.AzureAccountId);
    }

    if (!this.pharmacies || this.pharmacies.length == 0) {
      this.getPharmacies(this.currentEndpoint);
    }
  }

  fetchRelevantNamespaces(endpoint: AzureEndpointDisplay = null) {
    if (!this.selectedAzureAccount)
      return;

    this.azureNamespaces = new Array();
    this.selectedAzureNamespace = null;

    this.azureNamespaceService.getNamespacesByAccountId(this.selectedAzureAccount.Id)
      .subscribe((dataList: AzureNamespace[]) => {
        if (dataList && dataList.length > 0) {
          this.azureNamespaces = dataList;

          if (endpoint && this.azureNamespaces) {
            this.selectedAzureNamespace = this.azureNamespaces.find(x => x.Id == endpoint.AzureNamespaceId);
          }
        }
      });
  }

  getEndpointCountsForNamespace() {
    this.azureNamespaceService.getEndpointsCount(this.selectedAzureNamespace.Id)
      .subscribe((response: number) => {
        this.endpointsCountForSelectedNamespace = response;
        this.textForEndpointsCount = `Total related endpoints: ${response}.`;
        if (ALLOWED_MAXIMUM_ENDPOINTS_PER_NAMESPACE - response > 0) {
          this.textForEndpointsCount = `${this.textForEndpointsCount} Another ${ALLOWED_MAXIMUM_ENDPOINTS_PER_NAMESPACE - response} new endpoints can be created.`;
        }
        else {
          this.textForEndpointsCount = `${this.textForEndpointsCount} No more endpoints can be created.`;
        }
      });
  }

  onAccountChanged() {
    this.fetchRelevantNamespaces();
    this.getFullUrl();
  }
  
  onNamespaceChanged() {
    this.getFullUrl();
    this.getEndpointCountsForNamespace();
  }

  onPharmacyChanged() {
    if (!this.selectedPharmacy)
      return; 
    this.f.endpoint.setValue(this.selectedPharmacy.NpiNo);
    this.getFullUrl();
  }

  getFullUrl() {
    if (this.selectedAzureNamespace && this.selectedPharmacy) {

      const npiNo = this.selectedPharmacy.NpiNo;
      const namespace = this.selectedAzureNamespace.Namespace;
      this.fullUrl = `https://${namespace}.servicebus.windows.net/${npiNo}`;
      this.f.endpoint.setValue(this.selectedPharmacy.NpiNo);
    }
  }

  createEditEndpoint() {
    if (this.isBusy)
      return;

    this.isErrorVisible = false;
    this.isBusy = true;
    this.isLoading = true;
    this.isValid = true;

    if (this.f.endpoint.value) {
      this.isEndpointEntered = true;
    }
    else {
      this.isEndpointEntered = false;
    }

    this.isAccountSelected = true;
    this.isNamespaceSelected = true;
    this.isPharmacySelected = true;

    if (!this.selectedAzureAccount) {
      this.isAccountSelected = false;
    }

    if (!this.selectedAzureNamespace) {
      this.isNamespaceSelected = false;
    }

    if (!this.selectedPharmacy) {
      this.isPharmacySelected = false;
    }

    if (!this.isEndpointEntered || !this.isAccountSelected || !this.isNamespaceSelected || !this.isPharmacySelected) {
      this.isBusy = false;
      this.isLoading = false;
      return;
    }

    this.getFullUrl();
    if (!this.fullUrl) {
      this.error = "Npi number is not found for pharmacy";
      this.isErrorVisible = true;
      this.isLoading = false;
      this.isBusy = false;
      return;
    }

    if (ALLOWED_MAXIMUM_ENDPOINTS_PER_NAMESPACE - this.endpointsCountForSelectedNamespace <= 0) {
      this.error = "Selected namespace has reached its quota, no more endpoints can be associated";
      this.isErrorVisible = true;
      this.isLoading = false;
      this.isBusy = false;
      return;
    }

    let request = new AzureEndpoint();
    request.EndpointName = this.f.endpoint.value;
    request.AzureAccountIdFk = this.selectedAzureAccount.Id;
    request.AzureNamespaceIdFk = this.selectedAzureNamespace.Id;
    request.PharmacyNpi = this.selectedPharmacy.NpiNo;
    request.FullyQualifiedUrl = this.fullUrl;
    request.Active = true;

    let isActive: boolean = false;
    if (this.f.checkActive.value != null) {
      isActive = this.f.checkActive.value;
    }

    if (this.azureEndpointId && this.azureEndpointId > 0) { //TRYING TO UPDATE STATUS
      let updateRequest = new UpdateActiveStatusRequest();
      updateRequest.id = this.azureEndpointId;
      updateRequest.active = isActive;

      this.azureEndpointsService.updateActiveStatus(updateRequest)
        .pipe(first())
        .subscribe(
          data => {
            this.isLoading = false;
            this.isBusy = false;
            this.isEndpointSaved.emit(true);
            this.activeModal.close();
          },
          error => {
            this.error = error;
            this.isErrorVisible = true;
            this.isLoading = false;
            this.isBusy = false;
          }
        )
    }
    else { //TRYING TO CREATE A NEW ACCOUNT
      request.Id = 0;
      //NOW CREATE ON THE MICROSOFT'S AZURE
      this.createAzureEndpoint(request);
    }

  }

  deleteAzureEndpoint(request: AzureEndpoint) {
    this.azureOperationsService.deleteAzureHybridConnection(
      this.selectedAzureAccount.SubscriptionId,
      this.selectedAzureNamespace.ResourceGroup,
      this.selectedAzureNamespace.Namespace,
      request.EndpointName)
      .pipe(first())
      .subscribe(result => {
        this.isLoading = false;
        this.isBusy = false;

        this.isEndpointSaved.emit(true);
        this.activeModal.close();
      },
        (error: AzureErrorResponse) => {
          this.isErrorVisible = true;
          this.error = error.message;
          this.isLoading = false;
          this.isBusy = false;
        });
  }

  createAzureEndpoint(request: AzureEndpoint) {
    this.azureOperationsService.createAzureHybridConnection(
      this.selectedAzureAccount.SubscriptionId,
      this.selectedAzureNamespace.ResourceGroup,
      this.selectedAzureNamespace.Namespace,
      request.EndpointName)
      .pipe(first())
      .subscribe(result => {
        this.azureEndpointsService.createEndpoint(request)
          .pipe(first())
          .subscribe(
            data => {
              this.isLoading = false;
              this.isBusy = false;

              this.isEndpointSaved.emit(true);
              this.activeModal.close();
            }
          )
      },
        (error: AzureErrorResponse) => {
          this.error = error.message;
          this.isErrorVisible = true;
          this.isLoading = false;
          this.isBusy = false;
        });
  }

  getAccounts() {
    this.azureAccountService.getAccounts(1, 50000)
      .subscribe((dataList: AzureAccount[]) => {
        if (dataList && dataList.length > 0) {
          this.azureAccounts = dataList;
        }
      });
  }

  getPharmacies(endpoint: AzureEndpointDisplay = null) {
    if (this.pharmacies && this.pharmacies.length > 0)
      return;

    this.pharmacyService.getCompactList()
      .subscribe((dataList: PharmacyCompact[]) => {
        if (dataList && dataList.length > 0) {
          this.pharmacies = dataList;

          if (endpoint) {
            this.selectedPharmacy = this.pharmacies.find(pharmacy => pharmacy.NpiNo == endpoint.PharmacyNpi);
            var item = this.selectedPharmacy;
            if (!this.data || !this.data.some(x => x.PharId == item.PharId)) {
              var cData = { Pharmacy: item.Pharmacy, PharId: item.PharId, NpiNo: item.NpiNo, StreetAddress: item.StreetAddress, City: item.City, State: item.State, ZIPCode: item.ZIPCode };
              this.data.push(cData);
              //SELECT THIS PHARMACY IN THE DROPDOWN
              this.pharmacyDropdown.value = cData.PharId;
              this.isDropdownReadOnly = true;
            }
            this.getFullUrl();
          }
        }
      });
  }
  filterPharmacy(sQuery: string) {
    var filterList = this.pharmacies.filter(x => x.Pharmacy.includes(sQuery) || x.NpiNo.includes(sQuery) || x.StreetAddress.includes(sQuery) || x.State.includes(sQuery) || x.City.includes(sQuery) || x.ZIPCode.includes(sQuery));
    if (filterList && filterList.length > 0) {
      filterList.forEach(item => {
        if (!this.data || !this.data.some(x => x.PharId == item.PharId)) {
          //CREATING LIST FOR THE SYNCFUSION DROPDOWN LIST
          var cData = { Pharmacy: item.Pharmacy, PharId: item.PharId, NpiNo: item.NpiNo, StreetAddress: item.StreetAddress, City: item.City, State: item.State, ZIPCode: item.ZIPCode };
          this.data.push(cData);
        }
      })
    }
  }
}
